import $ from 'jquery';
//import { swipeInit } from './swipe'
import { navigationInit, calculateNavigation } from './navigation'
import { backgroundInit } from './background'
//import initSwipenav from './swipe';

let current_device = '';
function init() {

    navigationInit();

    $(window).on("load", function () {
        // navigationSetup();
        // calculateNavigation();

        backgroundInit();
        //
        // $(document).on('pub:viewport', function (event, device) {
        //     //console.log('refresh');
        //     if(current_device !== window.document.device && current_device !== ''){
        //         //console.log(window.document.device);
        //         window.location='';
        //     } else {
        //         current_device = window.document.device;
        //     }
        // });
    });

    // Mobile article swipe magazine
    //initSwipenav();

    // swipeInit();
}

init();


